import {
    AbstractControl,
    FormBuilder,
    FormGroup,
    ValidatorFn,
} from '@angular/forms';

import { NDDFormErrorService } from '../ndd-ng-form-error/shared/ndd-ng-form-error.service';
import { NDDFormsBaseComponent } from './ndd-ng-forms.base-component';

/** Serviço de gerenciamento dos controles do formulário. */
export class NDDFormsBuilderService {
    /**
     * Adiciona o controle no formulário.
     *
     * @static
     * @param {FormGroup} form Formulário.
     * @param {NDDFormsBaseComponent} options Opções; para definir `controlValue` e `controlDisabled` no controle.
     * @returns {AbstractControl} Controle.
     * @memberof NDDFormsBuilderService
     */
    public static addControl(form: FormGroup, options: NDDFormsBaseComponent): AbstractControl {
        const fb: FormBuilder = new FormBuilder();
        const control: AbstractControl = fb.control(
            {
                value: options.controlValue,
                disabled: options.controlDisabled,
            },
        );

        form.addControl(options.controlKey, control);

        return control;
    }

    /**
     * Adiciona validadores do controle.
     *
     * @static
     * @param {AbstractControl} control Controle.
     * @param {ValidatorFn[]} validator Validadores.
     * @memberof NDDFormsBuilderService
     */
    public static addValidators(control: AbstractControl, validator: ValidatorFn[]): void {
        control.setValidators(validator);

        control.updateValueAndValidity();
    }

    /**
     * Gera mensagem inválida.
     *
     * @static
     * @param {AbstractControl} control Controle.
     * @param {NDDFormErrorService} formErrorService Serviço `NDDFormErrorService`.
     * @returns {string} Mensagem inválida, se houver.
     * @memberof NDDFormsBuilderService
     */
    public static generateInvalidMessage(control: AbstractControl, formErrorService: NDDFormErrorService): string {
        if (control.touched && control.invalid) {
            return formErrorService.message(control.errors);
        }

        return null;
    }
}
